import React from "react";
import twemoji from "twemoji";
import styled from "styled-components";

const getEmojiCode = decoratedText => {
  let emojiCode;
  twemoji.parse(decoratedText, function(icon, options, variant) {
    emojiCode = icon;
    return null;
  });
  return emojiCode;
};

const Emoji = ({ decoratedText, ...props }) => {
  const emojiCode = getEmojiCode(decoratedText);
  // const emojiCode = twemoji.convert.toCodePoint(decoratedText);
  // const emojiCodeFiltered = emojiCode.split("-fe0f")[0]; //sometimes the code contains a polluted section, which we remove here.
  const emojiUrl = `https://twemoji.maxcdn.com/2/svg/${emojiCode}.svg`;
  return (
    <EmojiContainer title={emojiCode} style={{ backgroundImage: `url(${emojiUrl})` }}>
      <span data-offset-key={props.offsetKey} data-text="true">
        {decoratedText}
      </span>
    </EmojiContainer>
  );
};

const EmojiContainer = styled.span`
  background-position: center;
  /* make sure the background the image is only shown once */
  background-repeat: no-repeat;
  background-size: contain;
  /* move it a bit further down to align it nicer with the text */
  vertical-align: middle;
  /*
  We need to limit the emoji width because it can be multiple characters
  long if it is a 32bit unicode. Since the proper width depends on the font and
  it's relationship between 0 and other characters it's not ideal. 1.95ch is not
  the best value, but hopefully a good enough approximation for most fonts.
  */
  display: inline-block;
  overflow: hidden;
  max-width: 1.95ch;
  /*
  Needed for iOS rendering to avoid some icons using a lot of height without
  actually needing it.
  */
  max-height: 1em;
  line-height: inherit;
  margin: -0.2ex 0em 0.2ex;
  /*
  In the past we used opacity: 0 to hide the original Emoji icon no matter what
  system it is. Recently we switched to color: transparent since it started to
  work in recent iOS version.
  */
  color: transparent;
  /*
  Some SVG files (say 2764 for :heart:) don't have default width/height, thus
  may not be rendered properly on some platforms/browsers (e.g., Windows 10 +
  Chrome 61).
  */
  min-width: 1em;
`;

export default Emoji;
